import { Base } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import GiftCard from '@/assets/images/icons/GiftCard.svg'
import Exchange from '@/assets/images/icons/Exchange.svg'
import CashIcon from '@/assets/images/icons/CashIcon.svg'
import { RefundMethod } from '@/domain/refund'
import { ItemAction } from '@/domain/returns'

interface CompensationLabelProps {
  refundMethod: RefundMethod | 'REFUND'
  action: ItemAction
}

const CompensationLabel: React.FC<CompensationLabelProps> = ({
  refundMethod,
  action
}) => {
  const { t } = useTranslation()

  const iconToUse = () => {
    if (action === 'EXCHANGE') return Exchange

    if (
      refundMethod === 'BANK_TRANSFER' ||
      refundMethod === 'ORIGINAL_PM' ||
      refundMethod === 'REFUND'
    ) {
      return CashIcon
    }
    return GiftCard
  }

  return (
    <Base.Badge tone="info" icon={<img className="size-3" src={iconToUse()} />}>
      {t(`refund_methods.${action === 'EXCHANGE' ? action : refundMethod}`)}
    </Base.Badge>
  )
}

export default CompensationLabel
